import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";

import api from "../services/api";
import Navbar from "../components/Navbar";
import "../styles/tables.css";
import { useAuth } from "../context/AuthContext";

function ManageAds() {
  const { token } = useAuth();
  const navigate = useNavigate();

  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] =
    useState("");

  const [currentPage, setCurrentPage] =
    useState(1);

  const adsPerPage = 10;

  useEffect(() => {
    fetchAds();
  }, []);

  const fetchAds = async () => {

    try {

      const response =
        await api.get("/ads");

      setAds(response.data);

    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);

    }

  };

  const handleDelete = async (id) => {

    const result =
      await Swal.fire({
        title: "Delete Advertisement?",
        text:
          "This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ef4444",
        cancelButtonColor: "#021658",
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel"
      });

    if (!result.isConfirmed) {
      return;
    }

    try {

      await api.delete(
        `/ads/${id}`,
        {
          headers: {
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      setAds(
        ads.filter(
          (ad) => ad.id !== id
        )
      );

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text:
          "Advertisement deleted successfully.",
        timer: 2000,
        showConfirmButton: false
      });

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text:
          error.response?.data
            ?.message ||
          "Unable to delete advertisement."
      });

    }

  };

  const filteredAds =
    ads.filter((ad) =>
      ad.title
        .toLowerCase()
        .includes(
          search.toLowerCase()
        )
    );

  const indexOfLastAd =
    currentPage * adsPerPage;

  const indexOfFirstAd =
    indexOfLastAd - adsPerPage;

  const currentAds =
    filteredAds.slice(
      indexOfFirstAd,
      indexOfLastAd
    );

  const totalPages =
    Math.ceil(
      filteredAds.length /
      adsPerPage
    );

  if (loading) {
    return (
      <div>
        <Navbar />
        <h2>Loading...</h2>
      </div>
    );
  }

  return (
    <div>
      <Navbar />

      <div className="container">

        <h1>
          Manage Advertisements
        </h1>

        <input
          type="text"
          placeholder="Search ads..."
          value={search}
          onChange={(e) =>
            setSearch(
              e.target.value
            )
          }
          className="search-input"
        />

        <div className="table-wrapper">

          <table className="custom-table">

            <thead>
              <tr>
                <th>ID</th>
                <th>Image</th>
                <th>Title</th>
                <th>Position</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>

              {currentAds.map(
                (ad) => (
                  <tr key={ad.id}>

                    <td>
                      {ad.id}
                    </td>

                    <td>
                      <img
                        src={ad.image_url}
                        alt={ad.title}
                        style={{
                          width: "60px",
                          height: "40px",
                          objectFit: "cover",
                          borderRadius: "6px"
                        }}
                      />
                    </td>

                    <td>
                      {ad.title}
                    </td>

                    <td>
                      {ad.position}
                    </td>

                    <td>
                      {ad.is_active
                        ? "Active"
                        : "Inactive"}
                    </td>

                    <td>

                      <button
                        title="Edit Ad"
                        className="icon-btn edit-btn"
                        onClick={() =>
                          navigate(
                            `/ads/edit/${ad.id}`
                          )
                        }
                      >
                        <FaEdit />
                      </button>

                      <button
                        title="Delete Ad"
                        className="icon-btn delete-btn"
                        onClick={() =>
                          handleDelete(
                            ad.id
                          )
                        }
                      >
                        <FaTrash />
                      </button>

                    </td>

                  </tr>
                )
              )}

            </tbody>

          </table>

        </div>

        <div className="pagination">

          <button
            disabled={
              currentPage === 1
            }
            onClick={() =>
              setCurrentPage(
                currentPage - 1
              )
            }
          >
            Previous
          </button>

          <span>
            Page {currentPage} of{" "}
            {totalPages || 1}
          </span>

          <button
            disabled={
              currentPage ===
                totalPages ||
              totalPages === 0
            }
            onClick={() =>
              setCurrentPage(
                currentPage + 1
              )
            }
          >
            Next
          </button>

        </div>

      </div>
    </div>
  );
}

export default ManageAds;